import React from "react";
import classnames from "classnames";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { IContentfulRichText } from "../../types/IContentfulRichText";
import options from "./options";
import "./styles.scss";

interface IProps {
  className?: string;
  containerClassNameOverride?: string;
  contrastText?: boolean;
  content?: IContentfulRichText;
  stripEmptyParagraphTags?: boolean;
  noContainer?: boolean;
}

const RichText: React.FunctionComponent<IProps> = ({
  content,
  className,
  contrastText = false,
  containerClassNameOverride,
  stripEmptyParagraphTags,
  noContainer = false,
}) => {
  if (!content) {
    return null;
  }

  const containerClassName = containerClassNameOverride || "rich-text-container";

  // let richTextContent = content;

  if (stripEmptyParagraphTags) {
    content.json.content = content.json.content.filter((c) => { // eslint-disable-line no-param-reassign
      const isParagraph = c.nodeType === "paragraph";
      const value = isParagraph ? (c.content[0] as any).value : "";
      return !(isParagraph && (value === "\n" || value === ""));
    });
  }

  if (noContainer) {
    return <>{documentToReactComponents(content.json, options)}</>;
  }

  return (
    <div
      className={classnames(className, containerClassName, {
        "contrast-text": contrastText,
      })}
      role="region"
      aria-label={`Rich text ${className}`}
    >
      {documentToReactComponents(content.json, options)}
    </div>
  );
};

export { RichText, IProps };
